// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const addressBook: Styleguide["addressBook"] = {};

export default addressBook;
